import axios from 'axios';

// Cross-Browser function to get chrome-equivalent of event.path
export const getEventPath = function (event) {
    if (event.composedPath) { return event.composedPath(); } // Chrome, Safari, Mozilla

	// Fallback for Edge:
    let path = [];
       let currentElem = event.target;
    while (currentElem) {
      path.push(currentElem);
      currentElem = currentElem.parentElement;
    }
    if (path.indexOf(window) === -1 && path.indexOf(document) === -1)
      path.push(document);
    if (path.indexOf(window) === -1)
      path.push(window);
    return path;
}

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const uploadPut = async function ({url, data, timeout=60*1000, progress_handler, controller} ) {
    const result = {
        response: null,
        error: 'error'
    };

    try {
	    let request = await axios.request({
            signal: controller?.signal,
		    method: "PUT",
		    url,
		    data,
		    timeout,
		    onUploadProgress: progress_handler,
	    });
        result.response = request;
        result.error = null;
    } catch (error) {
        result.error = error;
    }
	
	return result;
}

export const triggerUrlDownload = function (url) {
  let hiddenLink = document.createElement('a');
  hiddenLink.style.visibility="hidden";
  hiddenLink.setAttribute('href', url);
  //hiddenLink.setAttribute('download', obj.name);
  hiddenLink.click();
  hiddenLink.remove();
}

export const unfocus = function (e) { e.target.blur(); }
export const scrollTo = function (elem) { elem.scrollIntoView(); }

export const arrayIntoChunks = function (arr, chunkSize) {
  if (chunkSize <= 0) {return arr};
  var R = [];
  for (var i=0,len=arr.length; i<len; i+=chunkSize)
    R.push(arr.slice(i,i+chunkSize));
  return R;
}